import _ from 'lodash';

interface IDataGoogle {
  types: string;
  short_name: string;
  long_name: string;
}

/**
 * Reduces a Google Places address_components list into the portal's flat address fields. Reads postal_code into zip, administrative_area_level_1 and country into name and code objects, and locality into city, falling back to sublocality, sublocality_level_1 or administrative_area_level_2 for city only when locality supplied none.
 *
 * @param addressComponents - Google Places address components.
 * @returns An object holding the extracted zip, state, country and city.
 */
export const getDataGoogle = (addressComponents: IDataGoogle[]) => {
  const object = {};
  _.forEach(addressComponents, (element) => {
    if (typeof element.types !== 'undefined') {
      if (element.types[0] === 'postal_code') {
        _.assign(object, { zip: element.short_name });
      }
      if (element.types[0] === 'administrative_area_level_1') {
        const state = {
          name: element.long_name,
          code: element.short_name,
        };
        _.assign(object, { state });
      }
      if (element.types[0] === 'country') {
        const country = {
          name: element.long_name,
          code: element.short_name,
        };
        _.assign(object, { country });
      }
      if (element.types[0] === 'locality') {
        _.assign(object, { city: element.long_name });
      } else if (
        element.types.includes('sublocality') ||
        element.types.includes('sublocality_level_1') ||
        element.types.includes('administrative_area_level_2')
      ) {
        if (!(object as { city?: string }).city) {
          // *: Not assign city before
          _.assign(object, { city: element.long_name });
        }
      }
    }
  });
  return object;
};

/**
 * Maps the app's control size onto the Ant Design size the address autocomplete renders at. Promotes middle to large and small to middle, defaulting to large for any other value.
 *
 * @param size - App-level control size.
 * @returns The Ant Design size to render.
 */
export const getAntdSize = (size: 'large' | 'middle' | 'small' | undefined) =>
  size === 'middle' ? 'large' : size === 'small' ? 'middle' : 'large';
